export const SectionTitle = ({
  title,
  imageUrl,
}: {
  title: string;
  imageUrl?: string;
}) => (
  <div className="col-span-12">
    {imageUrl && <img src={imageUrl} alt="brand" />}
    <p className="font-bold mt-5 mb-0">{title}</p>
  </div>
);
